import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-29409c62")

_pushScopeId("data-v-29409c62")
const _hoisted_1 = { class: "timezone-session-form w-full text-gray-333" }
const _hoisted_2 = { class: "font-bold font-size-24 mb-4" }
const _hoisted_3 = { class: "mb-8 text-grey-3" }
const _hoisted_4 = { class: "mb-8" }
const _hoisted_5 = { class: "w-full input-container mb-4" }
const _hoisted_6 = { class: "w-full input-container mb-4" }
const _hoisted_7 = { class: "font-bold font-size-14 mb-1" }
const _hoisted_8 = { class: "flex flex-wrap" }
const _hoisted_9 = { class: "flex res-box flex-wrap" }
const _hoisted_10 = { class: "input-time res-box-element ml-2" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "mx-2 mt-3 text-center" }, "〜", -1)
const _hoisted_12 = { class: "flex res-box" }
const _hoisted_13 = { class: "input-time res-box-element ml-2" }
const _hoisted_14 = { class: "actions flex items-center" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-checkmark text-4xl" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-close text-4xl" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BackPreviousPage = _resolveComponent("BackPreviousPage")
  const _component_Input = _resolveComponent("Input")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputTime = _resolveComponent("InputTime")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_BackPreviousPage, { onClick: _ctx.onCloseSignupForm }, null, 8, ["onClick"]),
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('timezoneDivisionMaster')) + " : " + _toDisplayString(_ctx.formTitle), 1),
    _createVNode("div", _hoisted_3, _toDisplayString(_ctx.t('allRequiredFields')), 1),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_Input, {
          label: _ctx.t('timezoneDivisionCode'),
          placeholder: _ctx.t('pleaseEnter'),
          modelValue: _ctx.dataForm.time_zone_code,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataForm.time_zone_code = $event)),
          errors: _ctx.errors.time_zone_code,
          "onUpdate:errors": _cache[2] || (_cache[2] = ($event: any) => (_ctx.errors.time_zone_code = $event)),
          required: true,
          "error-server": _ctx.errorServer.time_zone_code,
          validated: _ctx.validated
        }, null, 8, ["label", "placeholder", "modelValue", "errors", "error-server", "validated"])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_Input, {
          label: _ctx.t('timezoneDivisionName'),
          placeholder: _ctx.t('pleaseEnter'),
          modelValue: _ctx.dataForm.time_zone_name,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dataForm.time_zone_name = $event)),
          errors: _ctx.errors.time_zone_name,
          "onUpdate:errors": _cache[4] || (_cache[4] = ($event: any) => (_ctx.errors.time_zone_name = $event)),
          required: true,
          validated: _ctx.validated,
          "error-server": _ctx.errorServer.time_zone_name
        }, null, 8, ["label", "placeholder", "modelValue", "errors", "validated", "error-server"])
      ]),
      _createVNode("div", null, [
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.t('timezoneDetails')), 1),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.dataForm.time_zone_details[0].time_zone_start_day_type,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dataForm.time_zone_details[0].time_zone_start_day_type = $event)),
              class: "text-center w-20 res-box-child",
              "options-select": _ctx.optionsChoseTime,
              "item-value": "value",
              "item-text": "text",
              required: true,
              validated: _ctx.validated,
              placeholder: _ctx.t('choice'),
              "error-server": 
                _ctx.errorServer[`time_zone_details.0.time_zone_start_day_type`]
              ,
              errors: 
                _ctx.errors[`time_zone_details.0.time_zone_start_day_type`]
              ,
              "onUpdate:errors": _cache[6] || (_cache[6] = ($event: any) => (
                _ctx.errors[`time_zone_details.0.time_zone_start_day_type`]
               = $event))
            }, null, 8, ["modelValue", "options-select", "validated", "placeholder", "error-server", "errors"]),
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_InputTime, {
                placeholder: "--:--",
                modelValue: _ctx.dataForm.time_zone_details[0].time_zone_start,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dataForm.time_zone_details[0].time_zone_start = $event)),
                "error-server": 
                  _ctx.errorServer[`time_zone_details.0.time_zone_start`]
                ,
                validated: _ctx.validated,
                required: true,
                errors: _ctx.errors[`time_zone_details.0.time_zone_start`],
                "onUpdate:errors": _cache[8] || (_cache[8] = ($event: any) => (_ctx.errors[`time_zone_details.0.time_zone_start`] = $event))
              }, null, 8, ["modelValue", "error-server", "validated", "errors"])
            ])
          ]),
          _hoisted_11,
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.dataForm.time_zone_details[0].time_zone_end_day_type,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.dataForm.time_zone_details[0].time_zone_end_day_type = $event)),
              class: "text-center w-20 res-box-child",
              "options-select": _ctx.optionsChoseTime,
              "item-value": "value",
              "item-text": "text",
              placeholder: _ctx.t('choice'),
              validated: _ctx.validated,
              required: true,
              "error-server": 
                _ctx.errorServer[`time_zone_details.0.time_zone_end_day_type`]
              ,
              errors: 
                _ctx.errors[`time_zone_details.0.time_zone_end_day_type`]
              ,
              "onUpdate:errors": _cache[10] || (_cache[10] = ($event: any) => (
                _ctx.errors[`time_zone_details.0.time_zone_end_day_type`]
               = $event))
            }, null, 8, ["modelValue", "options-select", "placeholder", "validated", "error-server", "errors"]),
            _createVNode("div", _hoisted_13, [
              _createVNode(_component_InputTime, {
                placeholder: "--:--",
                modelValue: _ctx.dataForm.time_zone_details[0].time_zone_end,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.dataForm.time_zone_details[0].time_zone_end = $event)),
                "error-server": 
                  _ctx.errorServer[`time_zone_details.0.time_zone_start`]
                ,
                validated: _ctx.validated,
                required: true,
                errors: _ctx.errors[`time_zone_details.0.time_zone_end`],
                "onUpdate:errors": _cache[12] || (_cache[12] = ($event: any) => (_ctx.errors[`time_zone_details.0.time_zone_end`] = $event))
              }, null, 8, ["modelValue", "error-server", "validated", "errors"])
            ])
          ])
        ]),
        _createVNode(_component_ErrorMessage, {
          "error-server": _ctx.errorServer[`working_style_special_overtimes`]
        }, null, 8, ["error-server"])
      ])
    ]),
    _createVNode("div", _hoisted_14, [
      _createVNode(_component_Button, {
        class: "h-12 mr-5",
        size: "large",
        disabled: _ctx.isDisabledBtn,
        onClick: _ctx.onSubmitForm
      }, {
        default: _withId(() => [
          _hoisted_15,
          _createTextVNode(" " + _toDisplayString(_ctx.submitText), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_Button, {
        class: "h-12",
        size: "large",
        variant: "outline-primary",
        onClick: _ctx.onCloseSignupForm
      }, {
        default: _withId(() => [
          _hoisted_16,
          _createTextVNode(" " + _toDisplayString(_ctx.t('cancel')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
})